import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton } from '~/components/atomic';
import { HelmetHead } from '~/components/common';
import { PAGE_ROUTE } from '~/constants';
import waiting from '~/assets/img/completion_images/not_yet.svg';

export default function SubscriptionWaiting() {
  const navigate = useNavigate();

  return (
    <>
      <HelmetHead title='Waiting' />

      <Container>
        <Wrapper>
          <div
            css={css`
              width: 100%;
            `}
          >
            <Title>Sorry,</Title>
            <Description>
              We're preparing that feature. <br /> We'll do our best to make it
              available as soon as possible
            </Description>
          </div>

          <ImageWrapper>
            <img src={waiting} alt='waiting' />
          </ImageWrapper>
        </Wrapper>
        <ButtonWrapper>
          <DefaultButton onClick={() => navigate(PAGE_ROUTE.MAIN)}>
            Go home
          </DefaultButton>
        </ButtonWrapper>
      </Container>
    </>
  );
}

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: ${theme.layout.chat_navigation_height} ${theme.layout.section_side}
      0;
  `}
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 40px;
`;

const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    margin: 50px 0 ${theme.layout.chat_navigation_height};
  `}
`;

const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.content.hierarchy1};
    ${theme.fontStyle.poppins.title}
  `}
`;
const Description = styled.p`
  ${({ theme }) => css`
    margin-top: 16px;
    color: ${theme.content.hierarchy2};
    ${theme.fontStyle.poppins.desc2_bold}
  `}
`;

const ImageWrapper = styled.div`
  width: 100%;

  img {
    width: 100%;
    height: auto;
  }
`;
